import {wsUrl} from '@/global';

const businessId = '20200002';
const splitSize = 100;
export default class Socket {
  constructor({
    io,
    dataIds,
    eventAndHandleTupleList,
    targetComponent,
  }) {
    this.connected = false;
    this.token = 123456;
    this.dataIds = dataIds;
    this.refreshState = false;
    this.eventAndHandleTupleList = eventAndHandleTupleList || [];
    this.targetComponent = targetComponent;
    this.socket = io(wsUrl, {query: {businessId}});
    this.socket.on('connect', () => {
      this.socket.emit(
          'authentication_event',
          JSON.stringify({token: this.token}),
          (data) => {
            if (data.code !== '200') return console.error(data.msg);
            this.sendMes();
          },
      );
      this.connected = true;
    });
    this.addEvent();
  }

  setRefreshState(value) {
    this.refreshState = !!value;
  }

  refresh({
    dataIds,
    eventAndHandleTupleList,
    targetComponent,
  }) {
    if (!this.socket) return;
    if (!this.refreshState) {
      this.removeEvent();
      this.setRefreshState(true);
      this.withdrawMes().finally(() => {
        this.setRefreshState(false);
        this.addEvent();
        this.sendMes();
      });
    }
    this.dataIds = dataIds;
    this.eventAndHandleTupleList = eventAndHandleTupleList;
    this.targetComponent = targetComponent;
  }

  getEventList(split = true) {
    const length = this.dataIds.length;
    const splitGroupLength = Math.ceil(length / splitSize);
    const dataIds = this.dataIds.join(',');
    const computeSplitGroup = (type, handle) => Array(splitGroupLength).
        fill(0).
        map((num, index) => {
          const start = num + index * splitSize;
          return {
            type, handle,
            dataIds: this.dataIds.slice(start, start + splitSize).join(','),
          };
        });
    if (!length) return [];
    const eventAndHandleTupleList = this.eventAndHandleTupleList;
    return (
        split ?
            eventAndHandleTupleList.map(
                ([event, handle]) => computeSplitGroup(event, handle)).
                reduce((result, current) => [...result, ...current], []) :
            eventAndHandleTupleList.map(([event, handle]) => ({
              type: event, dataIds, handle,
            }))
    ).filter(({handle}) => !!handle).
        map(({type, dataIds, handle}) => ({eventType: type, dataIds, handle}));
  }

  withdrawMes() {
    if (!this.connected) return Promise.resolve();
    const eventList = this.getEventList();
    const promises = [];
    eventList.forEach((event) => {
      promises.push(new Promise((resolve, reject) => this.socket.emit(
          'unsubscribe_message_event',
          JSON.stringify([event]),
          (data) => `${data.code}` === '200' ?
              resolve() :
              reject(new Error(data.msg)),
      )));
    });
    return Promise.all(promises);
  }

  sendMes() {
    if (!this.socket || !this.connected) return;
    const eventList = this.getEventList();
    eventList.forEach((event) => {
      this.socket.emit(
          'subscribe_message_event',
          JSON.stringify([event]),
          (data) => {
            if (`${data.code}` !== '200') return console.error(data.msg);
          },
      );
    });
  }

  parseData(jsonStr) {
    try {
      return jsonStr ? JSON.parse(jsonStr).data : {};
    } catch (e) {
      return {};
    }
  }

  judgingPrerequisites(data, handle) {
    if (this.refreshState) return;
    data = this.parseData(data);
    handle && handle(data, this.targetComponent);
  }

  addEvent() {
    this.getEventList(false).forEach(({eventType, handle}) => {
      this.socket.on(eventType,
          (data) => this.judgingPrerequisites(data, handle));
    });
  }

  removeEvent() {
    this.getEventList(false).forEach(({eventType}) => {
      this.socket.off(eventType);
    });
  }

  destroy() {
    this.socket?.close();
    this.socket = null;
  }
}
